import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { AquiferTestFieldsView } from '../../../../types/form-types'

export interface AquiferViewFormInterface {
  fields: Partial<AquiferTestFieldsView>
  isLoading: boolean
}

export default function AquiferTestDetailsViewForm({ fields, isLoading }: AquiferViewFormInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Details
      </Heading>
      <FormField isSkeleton={isLoading} label='Test date' labelId='testDateLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='testDateLabel' value={`${fields.testDate ?? ''}`} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Test type' labelId='testTypeLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='testTypeLabel' value={`${fields.testType ?? ''}`} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.maxFlowRate}
        isSkeleton={isLoading}
        label={`Max flow rate (${fields.pumpingRateUnit ?? ''})`}
        labelId='maxFlowRateLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='maxFlowRateLabel' value={`${fields.maxFlowRate ?? ''}`} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Pumping duration (mins)' labelId='pumpingDurationLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='pumpingDurationLabel'
          value={`${fields.pumpingDuration ?? ''}`}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.aquiferTypeId}
        isSkeleton={isLoading}
        label='Aquifer type'
        labelId='aquiferTypeLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='aquiferTypeLabel' value={`${fields.aquiferType ?? ''}`} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Boundary condition' labelId='boundaryConditionLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='boundaryConditionLabel'
          value={`${fields.boundaryCondition ?? ''}`}
        />
      </FormField>
    </>
  )
}
